import { DocumentNode } from 'graphql';

const clientAlwaysDirectiveValue = {
  "kind": "Directive",
  "name": {"kind": "Name", "value": "client"},
  "arguments": [{
    "kind": "Argument",
    "name": {"kind": "Name", "value": "always"},
    "value": {"kind": "BooleanValue", "value": true}
  }],
};
export const addClientAlwaysDirective = (doc: DocumentNode): DocumentNode => {
  return {
    ...doc,
    definitions: doc.definitions.map((node: any) => {
      return {
        ...node,
        ...(node.kind === 'OperationDefinition' ? {
          selectionSet: {
            ...node.selectionSet,
            selections: node.selectionSet.selections.map((selection: any) => {
              return {
                ...selection,
                directives: [
                  ...(selection.directives ? selection.directives : []),
                  clientAlwaysDirectiveValue,
                ]
              }
            })
          }
        } : {}),
      }
    })
  }
}
